import './pageNotFound.css';

export const PageNotFound = () => {
    return (
            <div className='pnf-container'>
                <div className='pnf-404'>4<span className='pnf-404-accent'>0</span>4</div>
                <div className='pnf-pnf'>Page <span className='pnf-pnf-accent'>Not</span> Found</div>
            </div>
    )
}